var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-link',{staticClass:"btn btn-secondary",attrs:{"to":{name: this.link}}},[_c('i',{staticClass:"fas fa-long-arrow-left mr-2"}),_vm._v(" "+_vm._s(_vm.$t('ui.back'))+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }